import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import Link from '#/components/basic/Link/Link';
import RouterLink from '#/components/basic/Link/RouterLink';

type PropsWrap = {
  $isHoverable: boolean;
  disabled: boolean;
  $fill: string;
  $padding?: string;
  $disableHoverStyles: boolean;
  $fontSize?: string;
};

const hoverStyles = css`
  &:hover {
    background-color: var(--black1);
  }
`;

const IconItemWrap = styled.div<PropsWrap>`
  padding: ${props => props.$padding || '8px 12px'};
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: ${props => (props.$isHoverable ? 'pointer' : 'initial')};
  font-size: ${props => props.$fontSize || 'var(--medium)'};

  > div {
    display: flex;
    align-items: center;
  }

  b {
    font-size: var(--medium);
  }

  ${props => (props.$disableHoverStyles || props.disabled ? '' : hoverStyles)}

  svg {
    fill: ${props => props.$fill};
  }

  &[disabled] {
    color: var(--gray3);
  }
`;

type Props = {
  disabled?: boolean;
  icon?: ReactNode;
  linkTo?: string;
  linkWindowTarget?: '_self' | '_blank';
  onClick?: () => void;
  children: ReactNode;
  color?: string;
  fontSize?: string;
  padding?: string;
  linkStyle?: any;
  disableHoverStyles?: boolean;
};

const IconClickable = ({
  icon,
  disabled = false,
  linkTo,
  onClick,
  children,
  color = 'var(--gray2a)',
  fontSize,
  padding,
  linkStyle,
  linkWindowTarget,
  disableHoverStyles = false,
}: Props) => {
  const main = (
    <IconItemWrap
      disabled={disabled}
      onClick={onClick}
      $isHoverable={!!(onClick || linkTo)}
      $fill={color}
      $fontSize={fontSize}
      $padding={padding}
      $disableHoverStyles={disableHoverStyles}
    >
      {icon && <div>{icon}</div>}
      <div>{children}</div>
    </IconItemWrap>
  );
  return linkTo ? (
    linkTo.startsWith('http') ? (
      <Link
        disabled={disabled}
        href={linkTo}
        target={linkWindowTarget}
        style={linkStyle}
      >
        {main}
      </Link>
    ) : (
      <RouterLink disabled={disabled} to={linkTo} style={linkStyle}>
        {main}
      </RouterLink>
    )
  ) : (
    main
  );
};

export default IconClickable;
